export default __webpack_public_path__ + "88c65804da2411c3acdd410c16920990.ogg";